import {required} from 'redux-form-validators';
import {mapValidatorsToRules} from '../../utils/validators';

export const validate = values =>
  mapValidatorsToRules(
    {
      period: [required()]
    },
    values
  );
